import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AuthService } from '../auth.service';
import { SystemGlobalsService } from '../../system-globals.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { SigninLearningCenterData } from '../auth-types';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  token: string = '';
  tokenChecked: boolean = false;
  tokenValid: boolean = false;

  password: string = '';
  passwordConfirm: string = '';

  chooseLc: boolean = false;
  system: string = '';
  
  public networks: SigninLearningCenterData[] = [];
  networkId: number = 0;

  public isBusyChanging: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthService, public globals: SystemGlobalsService, private toastService: ToastService) { }

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token');

    this.authService.checkPasswordResetToken(this.token).subscribe(success => {
      this.tokenChecked = true;

      if (success) {        
        this.tokenValid = success;
      }
      else {

      }
    });

    this.system = this.globals.constants.systemName;
  }

  checkPasswordForLength(): boolean {
    return this.password.length >= 6;
  }

  checkPasswordForLetter(): boolean {
    return /[a-zA-Z]+/.test(this.password);
  }

  checkPasswordForNumber(): boolean {
    return /\d+/.test(this.password);
  }

  checkPasswordForPunctuation(): boolean {
    return /[a-z].*[A-Z]|[A-Z].*[a-z]/.test(this.password) || /[!,.@#$]/.test(this.password);
  }

  checkPasswordForMatch(): boolean {
    return this.password.length > 0 && (this.password == this.passwordConfirm);
  }

  canChangePassword(): boolean {
    return this.checkPasswordForLength() && this.checkPasswordForLetter() && this.checkPasswordForNumber() && this.checkPasswordForPunctuation() && this.checkPasswordForMatch();
  }

  changePassword() {
    this.isBusyChanging = true;

    this.authService.changePasswordUsingReset(this.token, this.password, this.networkId).subscribe(
      data => {
        if (data) {
          if (data.chooseLC) {
            data.lcData.sort((a, b) => a.name.localeCompare(b.name));

            this.networks = data.lcData;
            this.chooseLc = true;
            this.isBusyChanging = false;
          }
          else {
            if (data.hasError) this.toastService.error(data.errorMessage, 'Error changing password');
            else window.top.location.href = '/home/index';
          }
        }
        else {
          this.toastService.error('Unable to change password, please try again later', 'Error changing password');
          this.isBusyChanging = false;
        }
      },
      error => {
        this.toastService.error('Unable to change password, please try again later', 'Error changing password');
        this.isBusyChanging = false;
      }
    );
  }

  selectNetwork(networkId: number) {
    this.networkId = networkId;
    this.changePassword();
  }

}